
import { sum } from './utils';


function findMonthIndex (date, months) {

    const year = date.getFullYear();
    const monthName = date.toLocaleString('default', { month: 'long' }).substring(0, 3);
    const d = monthName + "'" + year.toString().slice(-2);
    const index = months.findIndex(month => {
        return d === month.name;
    });
    return index;
}

function formatDateToYYYYMMDD(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth() is 0-based
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

function calculateResources(projectsData, teamsProjects, teams, projects, shirts, teamsData) {
    
    if (teamsProjects.length === teams.length 
        && teams.length > 0 
        && projectsData.length === projects.length
        && projects.length > 0) {

        var teamsDataCopy = [...teamsData];

        const totalMonthsAllocatedForProjects = projectsData.map((project, i) => {
            return project.map((month, j) => {
                return month.value !== '' ? 1 : 0;
            }).reduce((a, b) => a + b, 0);
        });

        teamsData.forEach((row, i) => {

            var teamSize = teams[i].members;
            
            row.forEach((col, j) => {

                const projectsPerTeam = teamsProjects[i].map((element, index) => {
                    element.project_id = index;
                    return element;}).filter(element => element.value !== '');
                
                var projectsForAGivenMonth = [];
                projectsData.forEach((project, projectId) => 
                    project.forEach((projectMonth, monthId) => {
                    if (monthId === j && projectMonth.value !== '') {
                        return projectsForAGivenMonth.push(projectId);
                    } 
                })); 

                const projectsPerTeamInAGivenMonth = projectsPerTeam.filter(element => {
                    return projectsForAGivenMonth.includes(element.project_id) 
                });

                const resources = projectsPerTeamInAGivenMonth.map(element => {
                    const tot = totalMonthsAllocatedForProjects[element.project_id] > 0 ? 
                        totalMonthsAllocatedForProjects[element.project_id] : 1;
                    return shirts.filter(shirt => 
                        shirt.name === element.value).map(shirt => 
                            shirt.resource_mos / tot)[0]
                });

                var newCell = teamSize - sum(resources);
                teamsDataCopy[i][j].value = Number(newCell.toFixed(2));
            });
        });

        return(teamsDataCopy);

    } else {
        return null;
    }
}


function generateProjectAllocations(startRange, endRange, monthRequiredToComplete, 
    dateRangeOfInterest, totalMonthsLength) {
    const totalMonths = totalMonthsLength === null ? endRange - startRange + 1 : totalMonthsLength;
    const [interestStart, interestEnd] = dateRangeOfInterest;
  
    const variations = [];
  
    for (let i = startRange; i <= endRange - monthRequiredToComplete + 1; i++) {
      const projectEnd = i + monthRequiredToComplete - 1;
  
      // Project must be fully within the dateRangeOfInterest
      if (i >= interestStart && projectEnd <= interestEnd) {
        const variation = Array(totalMonths).fill(0);
        for (let j = i; j < i + monthRequiredToComplete; j++) {
          variation[j - startRange] = 1; // Offset to zero-based index
        }
        variations.push(variation);
      }
    }
  
    return variations;
  }


function calculateLoss(beforeMatrix, afterMatrix, alpha, beta) {

    let overAllocationPenalty = 0;
    let utilizationReward = 0;

    for (let i = 0; i < beforeMatrix.length; i++) {
        for (let j = 0; j < beforeMatrix[i].length; j++) {
        const before = beforeMatrix[i][j].value;
        const after = afterMatrix[i][j].value;
        const diff = before - after;

        if (after < 0) {
            overAllocationPenalty += Math.abs(after);
        }

        if (diff > 0 && after >= 0) {
            utilizationReward += diff;
        }
        }
    }

    const loss = alpha * overAllocationPenalty - beta * utilizationReward;
    return loss;
}

function allocateResources(
        projects, 
        teams, 
        shirts, 
        months, 
        teamsProjects,
        allowFlexTime, 
        alpha, 
        beta
    ) {

        const matrixProj = Array(projects.length).fill().map(() => 
            Array(months.length).fill().map(() => 
                ({ value: "", className: "", tooltip: "" })));
        let projectsDataCopy = JSON.parse(JSON.stringify(matrixProj));

        // create empty teamsData matrix
        const matrixTeams = Array(teams.length).fill().map(() => 
            Array(months.length).fill().map(() => 
                ({ value: "", className: "", tooltip: "", readOnly: true })));
        
        matrixTeams.forEach((row, i) => {
            const membersNumb = teams[i].members;
            row.forEach((cell, j) => {
                cell.value = membersNumb;
            })});
        let teamsDataCopy = JSON.parse(JSON.stringify(matrixTeams));        
        let teamsCopy = JSON.parse(JSON.stringify(teams));
        let shirtsCopy = JSON.parse(JSON.stringify(shirts));
        let projectsCopy = JSON.parse(JSON.stringify(projects));

        const evaluateAllocation = (allocation, projectIndex, 
            projectsDataInput, teamsDataInput) => {

            const teamsDataInputCopy = JSON.parse(JSON.stringify(teamsDataInput));
            var newvalues = [];
            for (let i = 0; i < allocation.length; i++) {
                const value = allocation[i] === 1 ? 'x' : '';
                const checked = allocation[i] === 1 ? true : false;
                newvalues.push( {value: value, className: '', tooltip: '', checked: checked});
            }

            // update array in the data
            projectsDataInput[projectIndex] = newvalues;

            const teamsDataInputReallocated = calculateResources(projectsDataInput, teamsProjects, 
                teamsCopy, projectsCopy, shirtsCopy, teamsDataInput);
        
            // calculate sums
            const loss = calculateLoss(teamsDataInputCopy, teamsDataInputReallocated, alpha, beta);

            return( {loss: loss, projects: projectsDataInput, teams: teamsDataInputReallocated} );

        }

        const getBestAllocation = (project, projectIndex, months, 
            projectsDataInput, teamsDataInput) => {

            let date = null;
            if (project.deadline === null){
                const randomMonth = Math.floor(Math.random() * (months.length - 2)) + 2;
                date = months[randomMonth].date;   
            } else {
                if (new Date(project.deadline).getFullYear() > new Date(months[months.length - 1].date).getFullYear()) {
                    date = months[months.length - 1].date;
                } else {
                    date = new Date(project.deadline);
                }
                if (allowFlexTime){
                    const temp = new Date(project.deadline);
                    temp.setMonth(temp.getMonth() + 3);
                    if (temp > new Date(months[months.length - 1].date)) {
                        date = months[months.length - 1].date;
                    } else {
                        date.setMonth(date.getMonth() + 3);
                    }
                } 
    
            }
            
            const deadline = date;

            const deadlineMonthIndex = findMonthIndex(new Date(deadline), months) + 1;
            const dateRangeOfInterest = [0, deadlineMonthIndex];

            let allocationVariations = [];

            for (let k=deadlineMonthIndex; k >= 1; k--) {
                const alloc = generateProjectAllocations(
                    0, deadlineMonthIndex, k, dateRangeOfInterest, months.length
                );
                allocationVariations = allocationVariations.concat(alloc);
            }

            var lossArr = [];
            for (let n = 0; n < allocationVariations.length; n++) {
                
                const projAlloc = JSON.parse(JSON.stringify(projectsDataInput));
                const teamAlloc = JSON.parse(JSON.stringify(teamsDataInput));
                const alloc = allocationVariations[n];
                
                const result = evaluateAllocation(
                    alloc, 
                    projectIndex, 
                    projAlloc, 
                    teamAlloc);

                lossArr.push(result.loss);

            }

            // find first allocation with the smallest negative sum
            const minNegIndex = lossArr.indexOf(Math.min(...lossArr));

            const result = evaluateAllocation(
                allocationVariations[minNegIndex],
                projectIndex,
                projectsDataInput,
                teamsDataInput
            );

            return result;
        }

        // go thouugh the projects in priority list and find best allocation
        for (let i = 0; i < projectsCopy.length; i++) {
            
            const result = getBestAllocation(
                projectsCopy[i], i, months, projectsDataCopy, teamsDataCopy
            );
            
            teamsDataCopy = JSON.parse(JSON.stringify(result.teams));
            projectsDataCopy = JSON.parse(JSON.stringify(result.projects));

        }
        
        return {
            projects: projectsDataCopy,
            teams: teamsDataCopy
        };
}


export { formatDateToYYYYMMDD, allocateResources, calculateResources };


